import useOrientation from "@/hooks/useOrientation";
import { useMemo } from "react";

const Container = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  const orientation = useOrientation();

  return (
    <div className={"flex flex-col items-center "}>
      {children}
      {orientation === "portrait" && (
        <div className="text-sm text-white mt-2">{title}</div>
      )}
    </div>
  );
};

const CallController = ({
  className,
  showVideoButton,
  isVideoOpen,
  isTrackOn,
  isFullScreen,
  videoDisabled,
  onVideoToggle,
  onHangup,
  handleTrackClick,
  handleShowEmoji,
  handleFullScreenClick,
  handleCaptureScreen,
}: {
  className?: string;
  showVideoButton?: boolean;
  isVideoOpen: boolean;
  isTrackOn?: boolean;
  isFullScreen?: boolean;
  videoDisabled?: boolean;
  onVideoToggle: () => void;
  onHangup: () => void;
  handleTrackClick: () => void;
  handleShowEmoji: () => void;
  handleFullScreenClick: () => void;
  handleCaptureScreen: () => void;
}) => {
  const handleVideoToggle = () => {
    if (videoDisabled) return;
    onVideoToggle();
  };

  const title = useMemo(() => {
    return isVideoOpen ? "挂断" : "取消";
  }, [isVideoOpen]);

  const renderTrack = () => {
    if (!isVideoOpen) return null;
    return (
      <div
        className="w-20 h-20 flex justify-end items-center active:opacity-50"
        onClick={handleTrackClick}
      >
        <Container title="跟随">
          <img
            className="w-10 h-10"
            alt="跟随"
            src={
              isTrackOn
                ? require("@/assets/images/track-on.png")
                : require("@/assets/images/track-off.png")
            }
          />
        </Container>
      </div>
    );
  };

  const renderEmoji = () => {
    if (!isVideoOpen) return null;
    return (
      <div
        className="w-20 h-20 flex justify-center items-center active:opacity-50"
        onClick={handleShowEmoji}
      >
        <Container title="表情">
          <img
            className="w-10 h-10"
            alt="表情"
            src={require("@/assets/images/emoji.png")}
          />
        </Container>
      </div>
    );
  };

  const renderFullScreenButton = () => {
    if (!isVideoOpen) return null;
    return (
      <div
        className="w-20 h-20 flex justify-center items-center active:opacity-50"
        onClick={handleFullScreenClick}
      >
        <Container title="全屏">
          <img
            className="w-10 h-10"
            alt="全屏"
            src={
              isFullScreen
                ? require("@/assets/images/full-screen-exit.png")
                : require("@/assets/images/full-screen.png")
            }
          />
        </Container>
      </div>
    );
  };

  const renderScreenShotButton = () => {
    if (!isVideoOpen) return null;
    return (
      <div
        className="w-20 h-20 flex  items-center active:opacity-50"
        onClick={handleCaptureScreen}
      >
        <Container title="截屏">
          <img
            className="w-10 h-10"
            alt="截屏"
            src={require("@/assets/images/screenshot.png")}
          />
        </Container>
      </div>
    );
  };

  return (
    <div
      className={"w-full flex justify-center items-center z-10 " + className}
    >
      {renderTrack()}
      {renderEmoji()}
      <div className="flex gap-10 justify-center items-center mt-2 ">
        <Container title={title}>
          <div
            className={`flex justify-center items-center w-14 h-14 rounded-full active:opacity-50 bg-red-500`}
            onClick={onHangup}
          >
            <img
              className="w-8 h-8 mt-1"
              alt=""
              src={require("@/assets/images/call.png")}
            />
          </div>
        </Container>
        {videoDisabled && showVideoButton && (
          <Container title={"打开视频遥操"}>
            <div
              className={`flex justify-center items-center w-14 h-14 rounded-full opacity-70 bg-black`}
            >
              <img
                className="w-8 h-6"
                alt=""
                src={require("@/assets/images/video-off.png")}
              />
            </div>
          </Container>
        )}
        {!videoDisabled && showVideoButton && (
          <Container title={isVideoOpen ? "关闭视频遥操" : "打开视频遥操"}>
            <div
              className={`flex justify-center items-center w-14 h-14 rounded-full active:opacity-50 ${
                isVideoOpen ? "bg-white" : "bg-black"
              } 
            `}
              onClick={handleVideoToggle}
            >
              <img
                className="w-8 h-6 active:opacity-50"
                alt=""
                src={
                  isVideoOpen
                    ? require("@/assets/images/video-on.png")
                    : require("@/assets/images/video-off.png")
                }
              />
            </div>
          </Container>
        )}
      </div>
      {renderFullScreenButton()}
      {renderScreenShotButton()}
    </div>
  );
};

export default CallController;